<template>
  <v-dialog
    v-model="isOpenInner"
    max-width="600px"
    persistent
  >
    <v-card>
      <v-card-title>Добавление пользователей "{{project}}"</v-card-title>
      <v-card-text>
        <v-select
          multiple
          :items="innerUsers"
          v-model="selectedUsers"
          no-data-text="Нет доступных пользователей..."
        ></v-select>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="isOpenInner = !isOpenInner">Отмена</v-btn>
        <v-btn text color="success" @click="addUserRole" :disabled="!selectedUsers.length">Добавить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import asyncQuery from "../../../asyncQuery";

  export default {
    name: "AddUserRole",
    data: () => {
      return {
        selectedUsers: [],
      }
    },
    props: {
      alreadyIncludedUsers: Array,
      project: String,
      isOpen: Boolean,
      toggleUserRoleDialog: Function,
      getProjects: Function,
      toggleLoading: Function,
      users: Array,
      getAllUsers: Function,
    },
    computed: {
      isOpenInner: {
        get: function () {
          return this.isOpen;
        },
        set: function () {
          this.selectedUsers = [];
          this.toggleUserRoleDialog();
        }
      },
      innerUsers: function () {
        return this.users
          .filter(el => el.roles.indexOf('admin') === -1)
          .map(el => el.user)
          .filter(el => !new Set([...this.alreadyIncludedUsers]).has(el))
      }
    },
    methods: {
      addUserRole: function () {
        asyncQuery.bind(this)({
          url: '/api/add_user_role',
          method: 'POST',
          json: true,
          body: JSON.stringify({
            project: this.project,
            users: this.selectedUsers,
          }),
          handleSuccess: () => {
            this.toggleUserRoleDialog();
            this.getProjects();
            this.$data.selectedUsers = [];
          }
        })
      },
    },
  }
</script>

<style scoped>

</style>
